import { render, staticRenderFns } from "./waybillInfo.vue?vue&type=template&id=5c6fabd9&scoped=true"
import script from "./waybillInfo.vue?vue&type=script&lang=js"
export * from "./waybillInfo.vue?vue&type=script&lang=js"
import style0 from "./waybillInfo.vue?vue&type=style&index=0&id=5c6fabd9&scoped=true&lang=scss"
import style1 from "./waybillInfo.vue?vue&type=style&index=1&id=5c6fabd9&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6fabd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6fabd9')) {
      api.createRecord('5c6fabd9', component.options)
    } else {
      api.reload('5c6fabd9', component.options)
    }
    module.hot.accept("./waybillInfo.vue?vue&type=template&id=5c6fabd9&scoped=true", function () {
      api.rerender('5c6fabd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/waybillInfo.vue"
export default component.exports